import ReactDOM from 'react-dom';
import './index.scss';
import SSOACEP from './components/common/SSO';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { requestConfirm } from './utils/routerConfirm';
import PublicCMERequirementsPage from './components/CMERequirementManagement/PublicCMERequirementsPage';

const queryClient = new QueryClient();



ReactDOM.render(
<QueryClientProvider client={queryClient} >
<BrowserRouter getUserConfirmation={(_message, callback) => requestConfirm(callback)}>
  <Switch>
    <Route path="/cme-requirements" exact component={PublicCMERequirementsPage} />
    <Route component={SSOACEP} />
  </Switch>
</BrowserRouter>
<ReactQueryDevtools initialIsOpen={false} /> 
</QueryClientProvider>  
,document.getElementById('root')
);

 
